import React from 'react';

import cs from 'classnames';
import styled from 'styled-components';

import {ItemWithChildrenStructure} from './ItemWithChildrenStructure';

import type {ReactNode} from 'react';

interface Props {
  icon: ReactNode | null;
  title: ReactNode;
  expanded: boolean;
  onToggleExpand: () => unknown;
  loading?: boolean;
  children?: ReactNode;
  actionsChildren?: ReactNode;
  childrenClass?: string;
}
export const CollapsibleItemStructure = ({
  icon,
  title,
  expanded,
  children = null,
  loading,
  actionsChildren = null,
  onToggleExpand,
  childrenClass,
}: Props) => {
  return (
    <ItemWithChildrenStructure
      childrenClass={childrenClass}
      actionsChildren={actionsChildren}
      expandedChildren={expanded ? children : null}
    >
      <button
        className={cs(
          'btn px-0 py-2 flex-grow-1 d-flex align-items-center text-left'
        )}
        onClick={() => onToggleExpand()}
      >
        <div className="kb-item-icon-container">
          <StyledExpandibleDiv>
            <i
              className={cs(
                'expandable-icon fa-fw',
                loading ? 'fa fa-circle-notch fa-spin' : 'fas fa-chevron-right',
                {
                  expanded,
                }
              )}
            />
          </StyledExpandibleDiv>
        </div>
        {icon != null ? (
          <div className="kb-item-icon-container">{icon}</div>
        ) : null}
        {title}
      </button>
    </ItemWithChildrenStructure>
  );
};

const StyledExpandibleDiv = styled.div`
  .expandable-icon {
    transition: transform 100ms;
  }

  .expandable-icon.expanded {
    transform: rotate(90deg);
  }
`;
